// ══════════════════════════════════════════════
// ثوابت عامة للتطبيق — نُقلت من App.jsx (كانت متعرّفة على مستوى الملف هناك)
// عشان تبقى قابلة لإعادة الاستخدام في أي component من غير ما نستورد App.jsx
// كله، وعشان تسهّل قراءة App.jsx نفسه.
// ══════════════════════════════════════════════

export const DEFAULT_PROJECT = null;

export const STATUS_CONFIG = {
    'Completed': { color: '#10b981', bg: 'rgba(16,185,129,0.1)', border: 'rgba(16,185,129,0.2)', label: 'Completed' },
    'In Progress': { color: '#3b82f6', bg: 'rgba(59,130,246,0.1)', border: 'rgba(59,130,246,0.2)', label: 'In Progress' },
    'Pending': { color: '#f59e0b', bg: 'rgba(245,158,11,0.1)', border: 'rgba(245,158,11,0.2)', label: 'Pending' },
};

export const PRIORITY_CONFIG = {
    'Critical': { color: '#ef4444', bg: 'rgba(239,68,68,0.1)', border: 'rgba(239,68,68,0.2)' },
    'High': { color: '#f97316', bg: 'rgba(249,115,22,0.1)', border: 'rgba(249,115,22,0.2)' },
    'Medium': { color: '#f59e0b', bg: 'rgba(245,158,11,0.1)', border: 'rgba(245,158,11,0.18)' },
    'Low': { color: '#6b7280', bg: 'rgba(107,114,128,0.1)', border: 'rgba(107,114,128,0.15)' },
};

export const pconf = (p) => PRIORITY_CONFIG[p] || PRIORITY_CONFIG['Medium'];
export const sconf = (s) => STATUS_CONFIG[s] || STATUS_CONFIG['Pending'];

export const getTaskDuration = (startDate, endDate) => {
    if (!startDate || !endDate) return null;
    const start = new Date(startDate);
    const end = new Date(endDate);
    const days = Math.ceil((end - start) / (1000 * 60 * 60 * 24));
    return days;
};

// قائمة الفئات الممكنة للمستندات
export const DOCUMENT_CATEGORIES = [
    "Contract", "Drawing", "Permit", "Test Report",
    "Warranty", "Change Order", "Meeting Minutes",
    "Submittal", "Invoice", "Photo", "Other"
];

export const USERS = {
    "Khalid": {
        token: "",  // ← من .env
        name: "Khalid Jahinger",
        position: "",
        department: "",
        role: "",
        email: "",
        phone: "",
        avatar: "https://ui-avatars.com/api/?name=Khalid+Jahinger&background=gray&color=fff&size=200"
    },
    "bakri": {
        token: "",  // ← من .env
        name: "Bakri M.Awad",
        position: "",
        department: "",
        role: "",
        email: "",
        phone: "",
        avatar: "https://ui-avatars.com/api/?name=Bakri+Mohammed&background=gray&color=fff&size=200"

    },
    "Naif": {
        token: "",
        name: "Naif Alrammah",
        position: "",
        department: "",
        role: "",
        email: "",
        phone: "",
        avatar: "https://ui-avatars.com/api/?name=Naif+Alrammah&background=gray&color=fff&size=200"
    },

    "Mohamed": {
        token: "",
        name: "Mohamed Saad",
        position: "",
        department: "",
        role: "",
        email: "",
        phone: "",
        avatar: "https://ui-avatars.com/api/?name=Mohamed+Saad&background=gray&color=fff&size=200"
    }
};

// Company Information
export const COMPANY_INFO = {
    name: "Al Rammah International IT & Telecom Services Co (RITIS)",
    logo: process.env.REACT_APP_COMPANY_LOGO || '/images/logo.png',
    tagline: "Excellence in ICT & ELV Services",
    address: "Al-Khobar, Eastern Province, Saudi Arabia",
    phone: "+966 13 896 1700",
    email: "info@goritis.com",
    website: "www.goritis.com",
    founded: "1999",
    projects: "200+",
    clients: "300+",
    employees: "100+"
};
